import { Type } from "../Type";
export function record(keyType, valueType) {
    return new IslyRecord(keyType, valueType);
}
export class IslyRecord extends Type {
    keyType;
    valueType;
    class = "record";
    constructor(keyType, valueType) {
        super(() => `Record<${keyType.name}, ${valueType.name}>`);
        this.keyType = keyType;
        this.valueType = valueType;
    }
    is = (value) => !!(value &&
        typeof value == "object" &&
        !globalThis.Array.isArray(value) &&
        globalThis.Object.entries(value).every(([key, value]) => this.keyType.is(this.keyType.name == "number" && `${+key}` == key ? +key : key) && this.valueType.is(value)));
    createFlaw(value) {
        return {
            flaws: value &&
                typeof value == "object" &&
                !globalThis.Array.isArray(value) &&
                globalThis.Object.entries(value).flatMap(([key, propertyValue]) => [
                    this.keyType.flaw(this.keyType.name == "number" && `${+key}` == key ? +key : key),
                    this.valueType.flaw(propertyValue),
                ]
                    .map((flaw, index) => (flaw.isFlaw ?? true) && { property: key + ` (${["key", "value"][index]})`, ...flaw })
                    .filter(Boolean)),
        };
    }
    getValue(value) {
        return globalThis.Object.fromEntries(globalThis.Object.entries(value).map(([key, value]) => [key, this.valueType.get(value)]));
    }
}
//# sourceMappingURL=index.js.map